import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';

@Component({
    selector: 'dynfield-serial',
    template: require('./dynamic-fields.serial.component.html')
})
export class DynamicFieldSerialComponent implements OnChanges {
    @Input() version: any;
    @Input() field: any;
    @Input() fieldError: any;

    error: any = false;

    constructor(private dynamicFieldsService: DynamicFieldsService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes?.fieldError?.currentValue, this.field
            );
        }
    }
}
